<app-client-search-form
    [error]="error$ | async"
    [handlers]="handlersForm"
    [mediumTypes]="mediumTypes$ | async"
    [pending]="loading$ | async"
    [sellerSettings]="sellerSettings$ | async"
    [termCode]="termCode$ | async" />
